import { useEffect, useRef } from "react";

interface MapKitScriptProps {
  onLoad: () => void;
}

export default function MapKitScript({ onLoad }: MapKitScriptProps) {
  const loaded = useRef(false);

  useEffect(() => {
    if ("mapkit" in window && !loaded.current) {
      loaded.current = true;
      onLoad();
      return;
    }

    const existing = document.querySelector('script[src*="apple-mapkit"]');
    if (existing) {
      if ("mapkit" in window && !loaded.current) {
        loaded.current = true;
        onLoad();
      } else {
        existing.addEventListener("load", () => {
          if (!loaded.current) {
            loaded.current = true;
            onLoad();
          }
        });
      }
      return;
    }

    const script = document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.dataset.libraries = "annotations,map";
    script.src = "https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.core.js";
    script.addEventListener("load", () => {
      if (!loaded.current) {
        loaded.current = true;
        onLoad();
      }
    });
    document.head.appendChild(script);
  }, [onLoad]);

  return null;
}
